import { SCHEMA_VERSION, UBE_EVENT } from "../constants";
import { track } from "../tracker";
import type { ModalClickedPayload, ModalViewedPayload, ObjectInteractedPayload } from "../types";

const HELP_USAGE_TEXT = {
    OBJECT_NAME: "help_usage_text",
    MODAL_NAME: "help_usage_text",
    VIEW_LOCATION: "search_form",
    CLICK_LOCATION: "search_form",
    CLICK_TYPE_CLOSE: "close",
    CONTEXT: "searchForm",
} as const;

export const trackHelpUsageTextClick = (fieldName: string) => {
    const payload: ObjectInteractedPayload = {
        schemaVersion: SCHEMA_VERSION.OBJECT_INTERACTED,
        objectName: HELP_USAGE_TEXT.OBJECT_NAME,
        action: "click",
        fieldName,
        context: HELP_USAGE_TEXT.CONTEXT,
    };
    track(UBE_EVENT.OBJECT_INTERACTED, payload);
};

export const trackHelpUsageTextModalViewed = (fieldName: string) => {
    const payload: ModalViewedPayload = {
        schemaVersion: SCHEMA_VERSION.MODAL_VIEWED,
        modalName: HELP_USAGE_TEXT.MODAL_NAME,
        viewLocation: HELP_USAGE_TEXT.VIEW_LOCATION,
        context: `${fieldName}_field`,
    };
    track(UBE_EVENT.MODAL_VIEWED, payload);
};

export const trackHelpUsageTextModalClosed = (fieldName: string) => {
    const payload: ModalClickedPayload = {
        schemaVersion: SCHEMA_VERSION.MODAL_CLICKED,
        modalName: HELP_USAGE_TEXT.MODAL_NAME,
        clickType: HELP_USAGE_TEXT.CLICK_TYPE_CLOSE,
        clickLocation: HELP_USAGE_TEXT.CLICK_LOCATION,
        clickSubLocation: `${fieldName}_field`,
    };
    track(UBE_EVENT.MODAL_CLICKED, payload);
};
